import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { Tabs, Button, Space, App, Pagination } from 'antd';
import { eventBus } from '@/utils/eventBus';
import YourTownloopOrdersListService from '../../components/YourTownloopOrdersList/YourTownloopOrdersListService';
import styles from './ServiceOrders.module.scss';
import iocn2 from '@/assets/images/组件 2 – 2@2x.png';

import { getEmergencyServiceList, getUserServiceProductOrderPageList, getOrderByKeyword, getOrderById } from '@/api/order';
import { serviceCarpoolOrderStatus } from '@/utils/constants';
import { OrderData, TransformedOrder } from './order';
import CarpoolService from './CarpoolService';
import PostordersList from '../../components/PostordersList/PostordersList';
//使用国际化
import { useTranslation } from 'react-i18next';
import img1 from '@/assets/images/001.png';
import img2 from '@/assets/images/002.png';
// 接口返回的订单数据类型
interface OrderListResponse {
  code: number;
  message: string;
  data: OrderData[];
  total: number;
  totalPages: number;
  pageNum: number;
  pageSize: number;
}
// 新的紧急服务数据类型
interface EmergencyServiceUser {
  user_id: string;
  merchant_id: string;
  first_name: string;
  last_name: string;
  nick_name: string;
  username: string;
  email: string;
  phone: string | null;
  photo: string | null;
  gender: number;
  birthday: string | null;
  level: number;
  is_delete: boolean;
  create_time: string;
  update_time: string;
}

interface EmergencyServiceImage {
  file_id: string;
  product_id: string | null;
  product_media_id: string | null;
  product_media_type: string;
  product_media_file_url: string;
  product_media_video_cover_id: string | null;
}

interface EmergencyServiceData {
  emergency_service_id: string;
  user: EmergencyServiceUser;
  service_category: any[];
  // service_category: number[];
  problem_description: string;
  budget: string;
  budget_price: string;
  latitude: string;
  longitude: string;
  city_state: string;
  address: string;
  phone: string;
  appointment_time: string;
  images: EmergencyServiceImage[];
  status: number;
  create_time: string;
  distance: number;
}






//tabItems切换 
const generateTabItems = (t:(key:string)=>string) => {
  const orderStatusOptions = serviceCarpoolOrderStatus();
  const tabItems = [
    { label: t('common.All'), key: 'all' },
    ...orderStatusOptions.map(option => ({
      label: t('CarpoolService.'+option.label),
      key: option.value.toString()
    }))
  ];

  return tabItems;
};



// 订单状态映射 - 使用枚举
const getOrderStatusText = (status: number): string => {
  const orderStatusOptions = serviceCarpoolOrderStatus();
  const statusOption = orderStatusOptions.find(option => option.value === status);
  return statusOption?.label || 'Unknown Status';
};

const YourOrders: React.FC = () => {

  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  // 国际化
  const { t } = useTranslation();
  
  const tabItems = generateTabItems(t);

  // 分类切换状态 - Emergency Service默认选中
  const [activeCategory, setActiveCategory] = useState('emergencyService');

  //tab切换
  const [activeTab, setActiveTab] = useState('all');

  // 订单数据状态

  const [orders, setOrders] = useState<any[]>([]);
  const [emergencyOrders, setEmergencyOrders] = useState<any[]>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0
  });

  //状态切换tab事件
  const changeTab = (key: string) => {
    console.log('key', key);
    setActiveTab(key);
    // 切换tab时重新获取数据，传递order_status参数
    const orderStatus = key === 'all' ? undefined : parseInt(key);
    getOrderPageListData(1, pagination.pageSize, orderStatus);
  }

  // 切换分类
  const handleCategoryChange = (category: string) => {
    setActiveCategory(category);
  }   
  //消息列表关键字搜索
  const [searchValue, setSearchValue] = useState<string>('');

  const searchAction = () => {
    console.log('searchValue', searchValue);

    //如果搜索框为空，获取所有订单列表
    const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
    getOrderPageListData(1, pagination.pageSize, orderStatus, searchValue.trim());


  }

  // 搜索消息列表处理键盘回车事件
  const searchHandleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchAction();
    }
  }

  // 转换接口数据为组件需要的格式
  const transformOrderData = (orderData: OrderData): TransformedOrder => {
    const orderItems = orderData.order_item_list;

    // 获取第一个商品的图片
    const firstProduct = orderItems[0] || { product: { product_media_list: [], product_title: '' } };


    return {
      odId: orderData.parent_order?.order_id || '',
      id: orderData.service_order_id,
      date: new Date(orderData.created_time).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replace(/(\d+)\/(\d+)\/(\d+)/, '$3/$1/$2'),
      orderNumber: orderData.service_order_id,
      store: firstProduct.service_product.service_name || '',
      status: getOrderStatusText(orderData.service_order_status),
      order_status: orderData.service_order_status, // 添加原始订单状态数字
      products: orderItems.map(item => ({
        product_order_id: item?.service_order_id,
        id: item.service_order_item_id.toString(),
        product_id: item.service_product.service_id,
        img: item.service_product.service_product_main_images?.[0]?.media_file_url || '',
        title: item.service_product.service_name,
        specs: item.service_product_sales_specification,
        price: item.service_product_item_price,
        quantity: item.service_product_item_quantity,
        subtotalPrice: (Number(item.service_product_item_price) * Number(item.service_product_item_quantity)).toFixed(2),
      })),
      paidAmount: orderData.service_order_total_price,
      shippingFee: '0.00',
      is_delete: false
    };
  };



  // 处理订单id的回传业务
  const getId = (id: string, action: string) => {

    if (action === 'delete') {
      // 删除成功后重新获取列表数据
      const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
      getOrderPageListData(1, pagination.pageSize, orderStatus);
    } else if (action === 'cancel') {
      const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
      getOrderPageListData(pagination.current, pagination.pageSize, orderStatus);
    } else if (action === 'complete') {
      const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
      getOrderPageListData(pagination.current, pagination.pageSize, orderStatus);
    }

  }

  //分页change
  const paginationChange = (page: number, pageSize: number) => {
    console.log('page', page, pageSize);
    // 分页时保持当前tab状态
    const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
    getOrderPageListData(page, pageSize, orderStatus);
  }


  //获取订单页列表
  const getOrderPageListData = (
    pageNum: number = 1,
    pageSize: number = 10,
    orderStatus?: number,
    keyword?: string
  ) => {


    const params: any = { page_num: pageNum, page_size: pageSize };

    if (orderStatus !== undefined) {
      params.order_status = orderStatus;
    }

    if (keyword !== undefined) {
      params.keyword = keyword;
    }
    let api
    if(activeCategory === 'emergencyService'){
      api = getEmergencyServiceList
    }else{
      api = getUserServiceProductOrderPageList
    }
    api(params).then((res: OrderListResponse) => {
      console.log('========', res);
      if (res.code === 200) {
        // 转换数据格式
        // const transformedOrders = res.data.map(transformOrderData);

        // console.log('transformedOrders', transformedOrders);
        
        
        if(activeCategory === 'emergencyService'){
          setEmergencyOrders(res.data)
        }else{
          setOrders(res.data);
        }
        setPagination({
          current: res.pageNum,
          pageSize: res.pageSize,
          total: res.total,
          totalPages: res.totalPages
        });
      } else {
        message.error(res.message || t('ServiceOrders.Failedtogetorderlist'));
      }
    }).catch((error) => {
      console.error('Failed to get order list:', error);
      message.error(t('ServiceOrders.Failedtogetorderlist'));
    }).finally(() => {
    });
  }


  //mounted 和unmounted
  useEffect(() => {
     setEmergencyOrders([])
     console.log('Component mounted',orders);   
     getOrderPageListData(1, 10);
    return () => {

    }
  }, [activeCategory]);

  return (
    <div className={styles['order-box']}>
      <div className={styles['left-panel']}>
        {/* 分类切换table */}
        <div className={styles['category-switch-container']}>
          <div className={styles['category-switch']}>
            <div 
                className={`${styles['category-tab']} ${activeCategory === 'emergencyService' ? styles['active'] : ''}`}
                onClick={() => handleCategoryChange('emergencyService')}
              >
               Emergency Service
            </div>
            <div 
                className={`${styles['category-tab']} ${activeCategory === 'regular' ? styles['active'] : ''}`}
                onClick={() => handleCategoryChange('regular')}
              >
                {t('ServiceOrders.Regularservice')}
            </div>
            <div
              className={`${styles['category-tab']} ${activeCategory === 'carpool' ? styles['active'] : ''}`}
              onClick={() => handleCategoryChange('carpool')}
            >
              {t('ServiceOrders.CarpoolService')}
            </div>
          </div>
        </div>
        {activeCategory === 'carpool' ? (
          <>
            <CarpoolService />
          </>

        ) : (
          <>
            <Tabs
              className={styles['favorites-tabs']}
              items={tabItems}
              activeKey={activeTab}
              onChange={changeTab}
            />
            <div className={styles['search-btn-box']}>
              <div className={styles['sidebar-search']}>
                <input
                  value={searchValue}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
                  onKeyDown={searchHandleKeyDown}
                  type="text"
                  placeholder= {t('ServiceOrders.Enterproductinformationtosearch')}  
                />
                <img src={iocn2} alt="" onClick={searchAction} />
              </div>
              <Button className={styles['search-btn']} onClick={searchAction}>{t('ServiceOrders.Search')}</Button>
            </div>
            { activeCategory === 'emergencyService' ?<PostordersList orders={emergencyOrders}/>
            : <YourTownloopOrdersListService orders={orders} getId={getId} />
            } 
            
            <div className={styles['pagination-box']}>
              <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={paginationChange}
                showSizeChanger={false}
                showQuickJumper
                showTotal={(total, range) => `${t('common.Items')}：${range[0]}/${range[1]} ${t('common.Total')}：${total}`}
              />
            </div>
          </>
        )}

      </div>


    </div>
  );
};

export default YourOrders; 